export default __webpack_public_path__ + "static/media/2015-IMcover.e761f70f.jpg";